import logger from '../../../utils/logger';

export const validatePhotoFile = (file) => {
  if (!file.type.startsWith('image/')) {
    throw new Error('Please upload an image file');
  }
  if (file.size > 5 * 1024 * 1024) {
    throw new Error('File size must be less than 5MB');
  }
};

// Pass a File to upload a new photo, or a URL string to set an existing (e.g. MLS) photo as primary.
export const uploadPhoto = async (fileOrSourceUrl, parcelId, axiosInstance) => {
  try {
    const formData = new FormData();
    formData.append('parcel_id', parcelId);
    formData.append('bucket_name', 'aventine-photos');

    if (typeof fileOrSourceUrl === 'string') {
      formData.append('source_url', fileOrSourceUrl);
    } else {
      validatePhotoFile(fileOrSourceUrl);
      formData.append('photo', fileOrSourceUrl);
    }

    const response = await axiosInstance.post('/upload-photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data.photoUrl;
  } catch (error) {
    logger.error('Failed to upload photo:', error);
    throw error;
  }
};

export const deletePhoto = async (parcelId, axiosInstance) => {
  const response = await axiosInstance.post('/delete-photo', { parcel_id: parcelId });
  if (!response.data.success) {
    throw new Error('Failed to delete photo');
  }
};
